import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import candidateApi from "./api";

const initialState = {
  isLoading: false,
  candidates: {},
  suggestedCandidate: [],
  suggestCampaign: [],
  typeCandidates: [],
  filtersData: {},
};

export const listCandidate = createAsyncThunk("talent", async (values, thunk) => {
  try {
    values = decodeURI(values);
    const response = await candidateApi.listCandidate(values);
    return response.data;

  } catch (error) {
    return thunk.rejectWithValue(error);
  }
});


export const suggestCandidate = createAsyncThunk("employer/suggestionTalent", async (values, thunk) => {
  try {
    const response = await candidateApi.suggestionCandidate(values);
    return response.data;

  } catch (error) {
    return thunk.rejectWithValue(error);
  }
});

export const suggestCandidateCampaign = createAsyncThunk("talent/suggestion/Campaign", async (values, thunk) => {
  try {
    const response = await candidateApi.suggestionCandidateCampaign(values);
    return response.data;

  } catch (error) {
    return thunk.rejectWithValue(error);
  }
});

export const typeCandidate = createAsyncThunk("talent/Filter/PrivateEmp", async (values, thunk) => {
  try {
    const response = await candidateApi.typeCandidate(values);
    return response.data;

  } catch (error) {
    return thunk.rejectWithValue(error);
  }
});

export const filterCandidate = createAsyncThunk("talent/Filter/Details", async (values, thunk) => {
  try {
    const response = await candidateApi.filterCandidate(values);
    return response.data;
  } catch (error) {
    return thunk.rejectWithValue(error);
  }
});

export const candidateSlice = createSlice({
  name: "candidate",
  initialState: initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder

      // List Candidate
      .addCase(listCandidate.pending, (state) => {
        state.isLoading = true;        
      })
      .addCase(listCandidate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.candidates = action.payload;
      })
      .addCase(listCandidate.rejected, (state) => {
        state.isLoading = false;        
      })
      
      // Suggestion Candidate
      .addCase(suggestCandidate.pending, (state) => {
        state.isLoading = true;        
      })
      .addCase(suggestCandidate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.suggestedCandidate = action.payload;
      })
      .addCase(suggestCandidate.rejected, (state) => {
        state.isLoading = false;        
      })

      // Suggestion Campaign
      .addCase(suggestCandidateCampaign.pending, (state) => {
        state.isLoading = true;        
      })
      .addCase(suggestCandidateCampaign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.suggestCampaign = action.payload;
      })
      .addCase(suggestCandidateCampaign.rejected, (state) => {
        state.isLoading = false;        
      })

      // Type Candidate
      .addCase(typeCandidate.pending, (state) => {
        state.isLoading = true;        
      })
      .addCase(typeCandidate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.typeCandidates = action.payload;
      })
      .addCase(typeCandidate.rejected, (state) => {
        state.isLoading = false;        
      })

      // Filter Candidate
      .addCase(filterCandidate.pending, (state) => {
        state.isLoading = true;        
      })
      .addCase(filterCandidate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.filtersData = action.payload;
      })
      .addCase(filterCandidate.rejected, (state) => {
        state.isLoading = false;
      })

  },
});

export const candidateState = (state) => {
  return { ...state  };
};
